// removed by extract-text-webpack-plugin
module.exports = {"slide":"ScreenshotCarousel__slide-2iL9w","imageWrapper":"ScreenshotCarousel__imageWrapper-1WTpX"};